import request from './request.js';
import {
	requestbody
} from './request.js'

//登录接口
export async function login(params = {}) {
	return await request('/sys/login', 'post', params)
}
//获取登录验证码
export async function verifyCode(params = {}) {
	return await request('/sys/verifyCode', 'get', params)
}
//获取产品列表
export async function sysindex(params = {}) {
	return await request('/sys/index', 'get', params)
}
//退出登录
export async function loginOut(params = {}) {
	return await request('/sys/loginOut', 'post', params)
}